module.exports = __webpack_public_path__ + "img/about-case3.078f040c.jpg";